import { render, staticRenderFns } from "./DetHistory.vue?vue&type=template&id=f92637bc&"
import script from "./DetHistory.vue?vue&type=script&lang=js&"
export * from "./DetHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports